import React from "react";
import InfoTable from "../Tables/InfoTable";
import { useQuery } from "@apollo/client";

import { GET_ORG_INFO } from "../../queries";
import animetionLogo from "../../assets/utils/images/animetion_logo.gif";

const List = () => {
  const { loading, error, data } = useQuery(GET_ORG_INFO, {
    variables: { context: "" },
  });

  // ローディング
  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) return "...Error";

  const org_info = data.allOrgaccount.edges;

  let context = {};
  context["searchOrg"] = { edges: data.allOrgaccount.edges };

  const orgListData = context.searchOrg.edges.map((array) => array.node);

  return (
    <div>
      <InfoTable orgListData={orgListData} title="組織リスト" hideButtonCsv={true} />
    </div>
  );
};

export default List;
